import type { App } from '../../app/App';
import type { LuckyWheelDependencies } from '../luckyWheel/types';
import { ObservableValue } from '../../app/state/createObservableValue';
import { MetaPopupStackController } from '../../metaAbstractions/createMetaPopupController';
import type { ResourceMap } from '../../app/resources/types';
import { loadRemoteConfig, getPlatformRemoteConfig } from '../../app/firebase/getPlatformRemoteConfig';

export function createLuckyWheelDependencies(app: App): LuckyWheelDependencies {
  // Fetch ad spin count from remote config
  let { adSpins } = getPlatformRemoteConfig().feature.luckyWheel;
  void loadRemoteConfig(app).then(() => {
    adSpins = getPlatformRemoteConfig().feature.luckyWheel.adSpins;
  });

  return {
    observable: new ObservableValue(app.stateController, ['luckyWheel', 'levelIndex']),
    popupsController: new MetaPopupStackController(app.controller.popups),
    getAdsPlayer: () => app.ads ?? null,
    tracking: app.tracking,
    addResources: (resourceMap: ResourceMap, isAdSpin: boolean): void => {
      app.resources.addLuckyWheelReward(resourceMap, isAdSpin);
    },
    useRewardedFreeSpin: (): void => {
      app.resources.useRewardedLuckyWheelFreeSpin();
    },
    getAdSpins: (): number => adSpins,
  };
}
